import { ReactElement, ReactNode } from 'react';
import ReactModal from 'react-modal';

import Modal from '@rover/components/src/OverflowTextModal/Modal';
import { FlexProps } from '@rover/kibble/core';
import BottomSheet from '@rover/kibble/official-patterns/BottomSheet';
import MQ from '@rover/kibble/styles/MediaQuery';
import useTheme from '@rover/kibble/themes/useTheme';
import useMatchMedia from '@rover/react-lib/src/hooks/useMatchMedia';

export type DynamicModalProps = {
  children: ReactNode;
  isOpen: boolean;
  onRequestClose: () => void;
  isFullHeight?: boolean;
  mobileStyle?: ReactModal.Styles;
  desktopSX?: FlexProps['sx'];
};
/** A platform dependent modal. Renders as a `Modal` on desktop, or as a fullscreen `BottomSheet` on mobile. */
const DynamicModal = ({
  children,
  isOpen,
  onRequestClose,
  isFullHeight,
  mobileStyle = {},
  desktopSX = {},
}: DynamicModalProps): ReactElement => {
  const isMobile = useMatchMedia(MQ.MOBILE.getBreakpointString());
  const { colors } = useTheme();

  return isMobile ? (
    <BottomSheet
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      isFullHeight={isFullHeight}
      animationDirection="horizontal"
      style={{
        overlay: { backgroundColor: 'transparent' },
        content: {
          opacity: 1,
          outline: `1px solid ${colors.border.secondary}`,
        },
        ...mobileStyle,
      }}
      hideCloseIcon
    >
      {children}
    </BottomSheet>
  ) : (
    <Modal
      isOpen={isOpen}
      onClose={onRequestClose}
      hasCloseButton={false}
      sx={{ maxHeight: 'calc(100vh - 72px - 128px)', ...desktopSX }}
    >
      {children}
    </Modal>
  );
};
export default DynamicModal;
